import { type ActivityBookingField } from '@linktivity/ars-neo';

export function isURL(url: string) {
  return url.startsWith('http');
}

export const formatPrice = (price: string | number) => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getLanguageCode = (lang: string) => {
  return lang.toUpperCase();
};

export function isDefined<T>(val: T | undefined | null): val is T {
  return val !== undefined && val !== null;
}

export const snakeToCamelCase = (str: string): string =>
  str.toLowerCase().replace(/_([a-z])/g, (_, c: string) => c.toUpperCase());

export const getFieldIdentifier = (field: ActivityBookingField): string =>
  snakeToCamelCase(field.id || field.key || '');
